const passwordRegEx = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

export const passwordValidator = (password) => {
  if (!password.match(passwordRegEx)) {
    return "Password: min 8 characters (a-z, 0-9, special character)";
  }
};
